
export default {
  productData: {
    serialNumber: 'DA-MME-001',
    name: 'Massivholzdecke mit Estrich l Aufbau 1',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 10 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'm-20'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Massivholzdecke (Steico GLVL)' },
          output: 120,
          value: 'mh-120'
        }
      ],
      sum: {
        output: '200', value: 200
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '56 (-4; 2)',
        value: 56
      },
      soundReductionIndex: { // Rw
        output: '66 (-2; -8)',
        value: 66
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,55',
        value: 0.55
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '221 [kg/m²]'
      }
    }
  },
  image: 'da-mme-001.png',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-1-DA-MME-001-Rev01.pdf'
}
